import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { CATEGORIES } from "@/constants/categories";

export const AskBox = () => {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const q = text.trim();
    if (q) navigate("/solve", { state: { initial: q } });
  };
  return (
    <form onSubmit={submit} className="rounded-2xl bg-white p-3 shadow-lift ring-1 ring-navy/5 sm:p-4" data-testid="hero-ask-form">
      <label htmlFor="hero-ask" className="sr-only">{t("hero.placeholder")}</label>
      <textarea
        id="hero-ask"
        data-testid="hero-ask-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) submit(e); }}
        rows={3}
        maxLength={2000}
        placeholder={t("hero.placeholder")}
        className="w-full resize-none rounded-xl border-0 bg-paper/60 p-4 text-base text-navy placeholder:text-navy/45 focus:outline-none focus:ring-2 focus:ring-brand"
      />
      <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-medium text-navy/60">{t("hero.quick")}</span>
          {CATEGORIES.slice(0, 4).map((c) => (
            <button
              type="button" key={c.slug} data-testid={`hero-quick-${c.slug}`}
              onClick={() => setText(lang === "hi" ? c.sampleHi : c.sampleEn)}
              className="rounded-full border border-navy/10 bg-white px-3 py-1.5 text-xs font-medium text-navy hover:border-brand hover:bg-cyan-soft"
              style={{ transition: "background-color .2s, border-color .2s" }}
            >
              {lang === "hi" ? c.hi : c.en}
            </button>
          ))}
        </div>
        <button type="submit" disabled={!text.trim()} className="btn-primary shrink-0" data-testid="hero-ask-submit-button">
          {t("hero.ask")} <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </form>
  );
};
